// Order of import is important
import { $ } from 'bits/jquery'
import 'jquery-ui/ui/position'
import 'vendor/jquery.ui.touch-punch'
export { $ }
